import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[appMatchRegex]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MatchRegexDirective,
      multi: true
    }
  ],
  standalone: false
})
export class MatchRegexDirective implements Validator {
  @Input('appMatchRegex') desiredPattern: string | RegExp;

  static validator(control: AbstractControl, pattern: string | RegExp): ValidationErrors | null {
    if (!pattern) return null;

    const regex = pattern instanceof RegExp ? pattern : MatchRegexDirective.getRegExpFromString(pattern);

    const value: string = control.value;
    if (value && !regex.test(value)) {
      return { appMatchRegex: true };
    }
    return null;
  }

  static getRegExpFromString(str: string): RegExp {
    const regexWithDelimiters = /^\/(.+)\/([gimsuy]*)$/;
    let parts = str.match(regexWithDelimiters);

    if (parts) {
      let pattern = parts[1];
      let flags = parts[2];

      return new RegExp(pattern, flags);
    } else {
      return new RegExp(str);
    }
  }

  constructor() {}

  validate(control: AbstractControl): ValidationErrors | null {
    return MatchRegexDirective.validator(control, this.desiredPattern);
  }
}
